module.exports = __webpack_public_path__ + "img/marketing.5f36e409.svg";